import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const getCustomerTxnList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "GETLIMITS",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getCustomerTxnList, reqParams);
    return {
      status: response.status,
      data: response.data
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const updateTransactionLimit = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "UPDATELIMITS",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.updateTransactionLimit,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const changeUsernameVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "jije",
    };
    const response = await http.post(
      API_CONFIG.changeUsernameVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const changeUsernameConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "jije",
    };
    const response = await http.post(
      API_CONFIG.changeUsernameConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const setPrimaryAccount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "MPINRESETCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.setPrimaryAccount, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getDebitCardDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCOUNTDETAILS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.cardDetails, reqParams);
    return { status: response.status, data: response.data || {} };
  } catch (err) {
    return Promise.reject(err);
  }
};
const getAllCardFields = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "PROCESSFIELDS",
      requestId: "PROCESSFIELDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };

    const response = await http.post(API_CONFIG.getAllCardFields, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const blockDebitCardVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BLOCKDEBITCARD",
      requestId: "BLOCKDEBITCARDREQUEST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.blockDebitCardVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] || {} };
  } catch (err) {
    return Promise.reject(err);
  }
};

const blockDebitCardConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BLOCKDEBITCARD",
      requestId: "BLOCKDEBITCARDREQUEST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.blockDebitCardConfirm,
      reqParams
    );
    return { status: response.status, data: response.data["data"] || {} };
  } catch (err) {
    return Promise.reject(err);
  }
};

const newdebitCardRequestVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "DEBITCARD",
      requestId: "DEBITCARD_REQUEST",
    };

    const response = await http.post(
      API_CONFIG.newdebitCardRequestVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const newdebitCardRequestConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "DEBITCARD",
      requestId: "DEBITCARD_REQUEST",
    };

    const response = await http.post(
      API_CONFIG.newdebitCardRequestConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addOnCardRequest = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "DEBITCARD",
      requestId: "ADD_ON_CARD",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };

    const response = await http.post(API_CONFIG.requestAddOnCard, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const blockAccount = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "account",
      module: "accounts",
    };
    const response = await http.post(API_CONFIG.blockAccount, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deRegister = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "DEREGISTRATION",
      requestId: "DEREGISTRATION",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.deRegister, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardStatusUpdate = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "DEBITCARD_STATUS",
      //profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.debitCardStatusUpdate,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const enableOrDisableCard = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "DEBITCARD_STATUS",
      // profileId: parseInt(profileDetails["profileId"] || 0),
      // module: "card",
    };
    const response = await http.post(
      API_CONFIG.debitCardStatusUpdate,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const autoDisableDebitCard = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ACCOUNTDETAILS",
      profileId: parseInt(profileDetails["profileId"] || 0),
      module: "card",
    };
    const response = await http.post(
      API_CONFIG.autoDisableDebitCard,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const cardLimitUpdateVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "DEBITCARDLIMITS",
      requestId: "DEBITCARD_LIMITS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.cardLimitUpdateVerify,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const cardLimitUpdateConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "DEBITCARDLIMITS",
      requestId: "DEBITCARD_LIMITS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.cardLimitUpdateConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const pinCodeSerach = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "CHEQUE",
      module: "cheque",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.pinCodeSerach, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const doNotSendSMSInfo = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "DONOTSENDSMSINFO",
      module: "DONOTSENDSMS",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.doNotSendSMSInfo, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getDoNotSendSMSList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "GETDONOTSENDSMS",
      module: "DONOTSENDSMS",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getDoNotSendSMSList, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const doNotSendSMSSaves = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "UPDATEDONOTSENDSMS",
      module: "DONOTSENDSMS",
      profileId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.doNotSendSMSSaves, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const linkAccountVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "LINKACCOUNT",
      module: "LINKACCOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.linkAccountVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const linkAccountConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "LINKACCOUNT",
      module: "LINKACCOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.linkAccountConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const DeLinkAccountVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "DELINKACCOUNT",
      module: "DELINKACCOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.DeLinkAccountVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const DeLinkAccountConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "DELINKACCOUNT",
      module: "DELINKACCOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.DeLinkAccountConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAllOffers = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "GETOFFERS",
      module: "OFFERS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAllOffers, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAboutUs = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "ABOUT_US",
      module: "MPINLOGIN",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAboutUs, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const usercredVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: "REGISTRATION",
      requestId: "jije",
    };
    const response = await http.post(
      API_CONFIG.usercredVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const SettingsService = {
  getCustomerTxnList,
  updateTransactionLimit,
  changeUsernameVerify,
  changeUsernameConfirm,
  setPrimaryAccount,
  getDebitCardDetails,
  newdebitCardRequestVerify,
  blockAccount,
  deRegister,
  debitCardStatusUpdate,
  enableOrDisableCard,
  autoDisableDebitCard,
  addOnCardRequest,
  cardLimitUpdateVerify,
  cardLimitUpdateConfirm,
  pinCodeSerach,
  doNotSendSMSSaves,
  getDoNotSendSMSList,
  doNotSendSMSInfo,
  newdebitCardRequestConfirm,
  linkAccountVerify,
  linkAccountConfirm,
  DeLinkAccountVerify,
  DeLinkAccountConfirm,
  getAllOffers,
  getAboutUs,
  getAllCardFields,
  blockDebitCardVerify,
  blockDebitCardConfirm,
  usercredVerify,
};

export default SettingsService;
